import Vuelidate from 'vuelidate'

export default (Vue) => {
  Vue.use(Vuelidate)
}
